import "../css/PreferenceBar.css";

export default function PreferenceBar({ options, selectedPreference, onSelectPreference }) {
    return (
        <div className="preference-bar">
            <div className="preference-title">今天想偏向哪种感觉？</div>
            <div className="preference-options">
                {options.map((option) => {
                    const active = selectedPreference === option.id;
                    return (
                        <button
                            key={option.id}
                            className={`preference-chip ${active ? 'active' : ''}`}
                            onClick={() => onSelectPreference(option.id)}
                            type="button"
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
